import { MobileApp } from '../libs/proto/commUnity_pb';

export const communityAppType = MobileApp.AGWC;

export const desktopMode = 0;
export const desktopModeURL = '';
